import { render, staticRenderFns } from "./PopularUpcomingCard.vue?vue&type=template&id=ecace402"
import script from "./PopularUpcomingCard.vue?vue&type=script&lang=js"
export * from "./PopularUpcomingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports